import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

/**
 * Premium subscription paywall — shown when billing.status is not active.
 * @param {{
 *   featureLabel?: string,
 *   onGoBilling?: () => void,
 * }} props
 */
export default function UpgradePremiumCta({
  featureLabel = 'This feature',
  onGoBilling,
}) {
  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', py: { xs: 4, sm: 8 } }}>
      <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
        <LockOutlinedIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
          Upgrade to Premium
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          <strong>{featureLabel}</strong> requires an active Premium subscription.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Activate billing for your workspace to unlock enterprise reporting and advanced
          analytics powered by your data warehouse.
        </Typography>
        {onGoBilling && (
          <Button
            variant="contained"
            startIcon={<CreditCardOutlinedIcon />}
            onClick={onGoBilling}
          >
            View billing &amp; plan
          </Button>
        )}
      </Paper>
    </Box>
  );
}
